import { formatUnits, parseUnits } from 'viem'

export const calculateRewardRatePerSecond = (
  rewardRatePerMonth: string,
  rewardPeriod: number,
  decimals: number
): bigint => {
  try {
    const ratePerMonthBigInt = parseUnits(rewardRatePerMonth, decimals)
    const periodBigInt = BigInt(rewardPeriod)

    // The logic: Monthly amount / Period in seconds = Rate per second
    return ratePerMonthBigInt / periodBigInt
  } catch (error) {
    return 0n
  }
}

export const calculateMonthlyRewards = (
  rewardRatePerSecond: string,
  rewardPeriod: number,
  decimals: number
): string => {
  try {
    const ratePerSecondBigInt = parseUnits(rewardRatePerSecond, decimals)
    const periodBigInt = BigInt(rewardPeriod)
    // The logic: Rate per second * Period in seconds = Monthly amount
    const monthlyAmount = ratePerSecondBigInt * periodBigInt
    return formatUnits(monthlyAmount, decimals)
  } catch (error) {
    return '0'
  }
}
